// Вспомогательные функции для дропзон-файлов

const getShortName = function (filename) {
    let fileArr = filename.split(".");
    const ext = fileArr.pop();
    const name = fileArr.join(".");
    if (filename.length > 20 + ext.length) {
        filename = `${name.substring(0, 15)}...${name.substring(name.length - 2)}.${ext}`;
    }
    return filename;
};

export default {
    getShortName: getShortName,
};
